<div
  cdkDropList
  (cdkDropListDropped)="drop($event)"
  cdkDragLockAxis="y"
  [cdkDropListDisabled]="disabled"
>
  <div
    *ngFor="let section of sections"
    class="section-item d-flex full-width align-items-center relative"
    cdkDrag
    (cdkDragMoved)="service.onDragMoved($event)"
    cdkDragLockAxis="y"
    [cdkDragDisabled]="
      (disabled || sections?.length == 1) && !service.stepHover
    "
    id="section-{{ section.id }}"
  >
    <div class="drag-handler-container" *ngIf="!disabled && !service.stepHover">
      <button
        mat-icon-button
        cdkDragHandle
        [cdkDragHandleDisabled]="
          (disabled || sections?.length == 1) && !service.stepHover
        "
        color="accent"
        style="cursor: move"
      >
        <mat-icon>reorder</mat-icon>
      </button>
    </div>
    <workflow-section
      class="full-width mb-2"
      [wfTableConfig]="wfTableConfig"
      [section]="section"
      [disabled]="disabled"
      [sectionDropLists]="sectionDropLists"
      [stepDropLists]="stepDropLists"
      (delete)="delete($event)"
      (duplicate)="duplicate($event)"
    ></workflow-section>
  </div>
</div>
<button
  mat-stroked-button
  color="accent"
  class="mb-5 ml-1"
  *ngIf="!disabled"
  (click)="add()"
  [matTooltip]="'Add New Section'"
>
  <mat-icon>add_box</mat-icon> Add Section
</button>
